var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"archive gutter"},[_c('Archive')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }